import { useState, useEffect, useCallback } from "react";

export const useHideHelpBtn = () => {
  const [isHidden, setIsHidden] = useState<boolean>(false);

  const hideHelpBtn = useCallback(() => setIsHidden(true), [isHidden]);
  const showHelpBtn = useCallback(() => setIsHidden(false), [isHidden]);

  // the help button is set with a huge z-index so hide it from the dom on open
  useEffect(() => {
    const helpBtn = document.getElementById("reamaze-widget");
    const backToTop = document.getElementsByClassName("back-to-top")[0];

    if (!helpBtn) return;
    isHidden ? helpBtn.classList.add("hidden") : helpBtn.classList.remove("hidden");

    if (!backToTop) return;
    isHidden ? backToTop.classList.add("hidden") : backToTop.classList.remove("hidden");
  }, [isHidden]);

  return {
    hideHelpBtn,
    showHelpBtn,
  };
};
